'use client';

import { createContext, useContext, type ReactNode } from 'react';

const ServerAuthContext = createContext<boolean>(false);

interface ServerAuthProviderProps {
  hasAuthCookie: boolean;
  children: ReactNode;
}

export function ServerAuthProvider({ hasAuthCookie, children }: ServerAuthProviderProps) {
  return (
    <ServerAuthContext.Provider value={hasAuthCookie}>{children}</ServerAuthContext.Provider>
  );
}

export function useServerHasAuth(): boolean {
  return useContext(ServerAuthContext);
}
